import { buildAutocompleteOption } from '@/pages/rules/component-editor/utils/utils'
import orderBy from 'lodash/orderBy'

export const getters = {
  isAnyFormulaEditorProcessing (state) {
    return state.formulaEditorsProcessing > 0
  },
  suggestions (state) {
    return state.suggestions || []
  },
  componentsSuggestions (state) {
    return getters.suggestions(state).filter((suggestion) => suggestion.suggestionType === 'component')
  },
  valuesSetsSuggestions (state) {
    return getters.suggestions(state).filter((suggestion) => suggestion.suggestionType === 'values-set')
  },
  functionSuggestions (state) {
    return orderBy(getters.componentsSuggestions(state).map((suggestion) => buildAutocompleteOption(suggestion)), ['caption'], ['asc'])
  }
}
